import { createContext, useContext } from 'react';

const lbodtflexContext = createContext<string | null | undefined>(null);

export const LbodtflexContextProvider = lbodtflexContext.Provider;

export const useLbodtflexContext = () => useContext(lbodtflexContext);
